import styled from '@emotion/styled';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import UTILS from '@zola/zola-ui/src/styles/emotion/utils';

export const Box = styled.div`
  display: box;
  height: 0;
  position: relative;
  width: 0;
`;

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  background: ${COLORS.WHITE};
  ${UTILS.defaultBoxShadow};
  left: -6px;
  padding: ${SPACING.XS};
  position: absolute;
  top: 70px;
  z-index: 2000;
  cursor: pointer;

  svg {
    margin-right: 5px;
  }
`;
